import type { ReactNode } from 'react';

interface Props {
  /** El rótulo diminuto: DE QUÉ habla la tarjeta. */
  scope?: string;
  title?: ReactNode;
  /** Lo que va al final de la línea del título: un contador, una acción. */
  trail?: ReactNode;
  children?: ReactNode;
  /** El pie, separado por un hairline. */
  foot?: ReactNode;
  /** Levanta la tarjeta al pasar por encima. Sólo si de verdad se puede entrar. */
  interactive?: boolean;
  className?: string;
}

/**
 * El marco común, calcado de `Card.astro` de tbit-canvas: título, alcance y un
 * cuerpo. Nada de sombras grises ni esquinas vivas — eso lo pone el token.
 *
 * No reemplaza a `.card` de daisyUI: ES `.card` de daisyUI, con la cabecera que
 * las pantallas repetían a mano. Una pantalla que sólo necesita el marco puede
 * seguir escribiendo `<div className="card">` y sale igual de vestida.
 */
export default function Card({
  scope,
  title,
  trail,
  children,
  foot,
  interactive,
  className,
}: Props) {
  const classes = ['card', interactive && 'card--link', className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <div className="card-body">
        {(title || scope || trail) && (
          <div className="flex items-start justify-between gap-3 mb-3">
            <div className="min-w-0">
              {scope && <span className="brand-label block mb-1">{scope}</span>}
              {title && <h2 className="card-title">{title}</h2>}
            </div>
            {trail && <div className="flex items-center gap-2 shrink-0">{trail}</div>}
          </div>
        )}
        {children}
        {foot && (
          <div
            className="flex items-center gap-2 mt-4 pt-3 text-xs"
            style={{ borderTop: '1px solid var(--hairline)', color: 'var(--ink-faint)' }}
          >
            {foot}
          </div>
        )}
      </div>
    </div>
  );
}
